import { actualizarCantidadInventario } from "../infrastructure/supabase/procesoInventarioInicial.repository.js";

export async function actualizarInventarioInicialUseCase({ idInventario, cantidad }) {

  if (!idInventario) {
    throw new Error(
      "[actualizarInventarioInicialUseCase] idInventario es requerido"
    );
  }

  if (cantidad === undefined || cantidad === null) {
    throw new Error(
      "[actualizarInventarioInicialUseCase] cantidad es requerida"
    );
  }

  if (typeof cantidad !== "number" || Number.isNaN(cantidad)) {
    throw new Error(
      "[actualizarInventarioInicialUseCase] cantidad debe ser numérica válida"
    );
  }

  if (cantidad < 0) {
    throw new Error(
      "[actualizarInventarioInicialUseCase] cantidad no puede ser negativa"
    );
  }

  const resultado = await actualizarCantidadInventario({
    idInventario,
    cantidad
  });

  if (!resultado || resultado.success === false) {
    throw new Error(
      resultado?.error ||
      "[actualizarInventarioInicialUseCase] No se pudo actualizar"
    );
  }

  return resultado;
}